import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || "",

  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,

  // Only enable in production or if DSN is explicitly set
  enabled: !!import.meta.env.VITE_SENTRY_DSN,

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  // Sample rate for production
  tracesSampleRate: import.meta.env.VITE_SENTRY_ENVIRONMENT === "production" ? 0.1 : 1.0,

  integrations: [
    Sentry.browserTracingIntegration({
      enableLongTask: true,
      enableInp: true,
    }),
  ],

  // Drop noise from stale references to old build chunks after a deploy.
  // These are unactionable: the user just needs to reload, and the eager
  // public routes (form / video / gallery) are immune to this class of
  // error since CC-Stale-Chunk-Fix.
  ignoreErrors: [
    "Failed to fetch dynamically imported module",
    "Importing a module script failed",
    "is not a valid JavaScript MIME type",
    "Loading chunk",
    "ChunkLoadError",
    "Unable to preload CSS",
  ],

  // Filter out errors caused by Google Translate modifying the DOM
  beforeSend(event) {
    const message = event.exception?.values?.[0]?.value ?? "";
    if (message.includes("The object can not be found here")) {
      return null;
    }
    return event;
  },
});
